import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import FormPDI from "../../../h1Module/delivery/delivery/formPDIFinal";
import FormLocator from "./formLocator";

import Button from "../../../../modules/commons/Button";
import DDLSeries from "../../../../modules/commons/DDLSeries";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import SimpleInputRowSmall from "../../../../modules/SimpleInputRowSmall";
import SimpleInputRowSmally from "../../../../modules/SimpleInputRowSmally";
import DDLSeriesLong from "../../../../modules/commons/DDLSeriesLong";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class warehouse extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        ["1", "WH/00999/1", "WH 00999 Utama", "Active"],
        ["2", "WH/00999/2", "WH Pos 1 Old", "Inactive"],
        ["3", "WH/00999/3", "WH Pos 1 New", "Active"],
        ["4", "Call Content 4", "", ""],
        ["5", "Call Content 5", "", ""],
        ["6", "Call Content 6", "", ""],
      ],

      dataTable2: [
        ["1", "00999.WHB.S1", "Untuk Oil Scan", "WH/00999/1", "Active"],
        ["2", "00999.WHB.S1", "Untuk Oil Scan Old", "WH/00999/1A", "Inactive"],
        ["3", "00999.WHC.S1", "WHC.S1", "WH/00999/1", "Active"],
        ["4", "00999.WHA.S1", "WHA.S1", "WH/00999/1", "Active"],
        ["5", "Call Content 5", "", ""],
        ["6", "Call Content 6", "", ""],
        ["7", "Call Content 7", "", ""],
      ],

      dataTable3: [
        ["1", "HTL.01.1.1", "00999.WHA.S1", "WH/00999/4", "Active"],
        ["2", "HTL.01.1.2", "00999.WHA.S1", "WH/00999/4", "Inactive"],
        ["3", "Claim C2.A", "INV/021122/1", "WH/00999/1", "Active"],
        ["4", "Call Content 4", "", ""],
        ["5", "Call Content 5", "", ""],
        ["6", "Call Content 6", "", ""],
      ],
      selectedIndex: [],
      createVisible: false,
      createVisible2: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      failedPopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      // segmenType: [
      //   { label: "Matic", value: "Matic" },
      //   { label: "CUB", value: "CUB" },
      //   { label: "Sporty", value: "Sporty" },
      // ],
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},

      // subSegmenType: [
      //   { label: "Low", value: "Low" },
      //   { label: "Mid", value: "Mid" },
      //   { label: "High", value: "High" },
      // ],
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_SERIES").getSeries(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const { id, segmen, subsegmen, series } = value;
            return [id, segmen, subsegmen, series];
          });
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  handlePopUp2 = () => {
    this.handleSearch();
    this.setState({
      failedPopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openCreateForm2 = () => {
    this.setState({ createVisible2: !this.state.createVisible2 });
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openFailedPopUp = () => {
    this.setState({
      failedPopUpVisible: !this.state.failedPopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No" },
    { name: "Warehouse" },
    { name: "Deskripsi" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                style={{ marginLeft: "-5px" }}
                className="btn btn-back"
                type="button"
                onClick={this.openCreateForm.bind(this)}
              >
                <span>Edit</span>
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  columnsUser2 = [
    { name: "No" },
    { name: "SubInventory" },
    { name: "Deskripsi" },
    { name: "Warehouse" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                style={{ marginLeft: "-5px" }}
                className="btn btn-back"
                type="button"
                onClick={this.openCreateForm.bind(this)}
              >
                <span>Edit</span>
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  columnsUser3 = [
    { name: "No" },
    { name: "Locator" },
    { name: "Sub Inventory" },
    { name: "Warehouse" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                style={{ marginLeft: "-5px" }}
                className="btn btn-back"
                type="button"
                onClick={this.openCreateForm.bind(this)}
              >
                <span>Edit</span>
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  onchangeInput = (event) => {
    let nama = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [nama]: value,
      },
    });
  };

  onPostCreate = async () => {
    console.log("masuk function onPostCreate");
    if (
      R.isEmpty(this.state.seriesInput) ||
      R.isEmpty(this.state.selectedSegmenData) ||
      R.isEmpty(this.state.selectedSubSegmenData)
    ) {
      console.log("payload error");
      this.openFailedPopUp();
    } else {
      console.log("payloadCreated");
      let payloadCreate = {
        segmen: this.state.selectedSegmenData.SegmenSelect.value,
        subSegmen: this.state.selectedSubSegmenData.SubSegmenSelect.value,
        series: this.state.seriesInput.kodeId,
      };
      console.log("payloadCreate", typeof payloadCreate.series);

      let response = await API.create("LOCAL_SERIES").postCreateSeries(
        payloadCreate
      );
      if (response.data.code === 201) {
        console.log("postCreateSeriesSuccess", response);
        this.openSavePopUp();
      } else {
        // pop up gagal
        console.log("postCreateSeriesFailed", response);
        this.openFailedPopUp();
      }
    }
  };

  onClearFieldButton = () => {
    this.setState({
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},
    });
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      filter: false,

      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Warehouse</Tab>
              <Tab>Sub Inventory</Tab>
              <Tab>Locator</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div>
                  <SimpleInputRow
                    label={"Warehouse"}
                    name="warehouse"
                    // readOnly={this.props.type !== "create"}
                    value={this.state.data.warehouse}
                    onChange={this.onchangeInput}
                  />
                  <div></div>
                  <div>
                    <SimpleInputRow
                      label={"Deskripsi"}
                      name="deskripsi"
                      // readOnly={this.props.type !== "create"}
                      value={this.state.data.deskripsi}
                      onChange={this.onchangeInput}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div
                    //   style={{ float: "left", marginRight: "1vw" }}
                    className="padding-top-5px padding-bottom-10px"
                  >
                    <button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-back"
                      type="button"
                    >
                      <span>DELETE</span>
                    </button>
                    <button
                      style={{ marginLeft: "500px" }}
                      className="btn btn-green"
                      type="submit"
                      onClick={() => {
                        console.log("clicked");
                        this.onPostCreate();
                      }}
                    >
                      <span>{!this.state.loadSave ? "SAVE" : "Saving..."}</span>
                    </button>
                    <button
                      style={{ marginLeft: "40px" }}
                      className="btn btn-back"
                      type="button"
                      onClick={this.onClearFieldButton.bind(this)}
                    >
                      <span>CLEAR</span>
                    </button>
                  </div>
                </div>
                <div className="padding-top-10px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"Warehouse List"}
                      subtitle={"Setting data of Warehouse List"}
                      data={this.state.dataTable}
                      columns={this.columnsUser}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      style={{ marginLeft: "1290px", width: "50" }}
                      className="btn btn-back"
                      type="button"
                    >
                      <span>PRINT</span>
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div>
                <div>
                  <div style={{ width: 50, display: "flex" }}>
                    <div>
                      <DDLSeriesLong
                        box={"search"}
                        label={"Warehouse"}
                        hierarchy={false}
                        options={this.state.subSegmenType}
                        onChangeCombo={(value) => {
                          this.setState({
                            selectedSubSegmenData: {
                              ...this.state.selectedSubSegmenData,
                              ...value,
                            },
                          });
                        }}
                        valueCombo={
                          this.state.selectedSubSegmenData.SubSegmenSelect
                        }
                      />
                    </div>
                    <div style={{ marginTop: "15px"}}>
                      <SimpleInputRowSmall
                        label={"Deskripsi"}
                        name="deskripsii"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.deskripsii}
                        onChange={this.onchangeInput}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "15px"}}>
                    <SimpleInputRowSmally
                      label={"Sub Inventory"}
                      name="subInventoryy"
                      // readOnly={this.props.type !== "create"}
                      value={this.state.data.subInventoryy}
                      onChange={this.onchangeInput}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div
                    //   style={{ float: "left", marginRight: "1vw" }}
                    className="padding-top-5px padding-bottom-10px"
                  >
                    <button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-back"
                      type="button"
                    >
                      <span>DELETE</span>
                    </button>
                    <button
                      style={{ marginLeft: "500px" }}
                      className="btn btn-green"
                      type="submit"
                      onClick={() => {
                        console.log("clicked");
                        this.onPostCreate();
                      }}
                    >
                      <span>{!this.state.loadSave ? "SAVE" : "Saving..."}</span>
                    </button>
                    <button
                      style={{ marginLeft: "40px" }}
                      className="btn btn-back"
                      type="button"
                      onClick={this.onClearFieldButton.bind(this)}
                    >
                      <span>CLEAR</span>
                    </button>
                  </div>
                </div>
                <div className="padding-top-10px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"Sub Inventory List"}
                      subtitle={"Setting data of Sub Inventory List"}
                      data={this.state.dataTable2}
                      columns={this.columnsUser2}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      style={{ marginLeft: "1290px", width: "50" }}
                      className="btn btn-back"
                      type="button"
                    >
                      <span>PRINT</span>
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div>
                <div>
                  <DDLSeries
                    box={"search"}
                    label={"Warehouse"}
                    hierarchy={false}
                    options={this.state.segmenType}
                    onChangeCombo={(value) => {
                      this.setState({
                        selectedSegmenData: {
                          ...this.state.selectedSegmenData,
                          ...value,
                        },
                      });
                      console.log("data", this.state.selectedSegmenData);
                    }}
                    valueCombo={this.state.selectedSegmenData.SegmenSelect}
                  />

                  <DDLSeries
                    box={"search"}
                    label={"SubInventory"}
                    hierarchy={false}
                    options={this.state.subSegmenType}
                    onChangeCombo={(value) => {
                      this.setState({
                        selectedSubSegmenData: {
                          ...this.state.selectedSubSegmenData,
                          ...value,
                        },
                      });
                    }}
                    valueCombo={
                      this.state.selectedSubSegmenData.SubSegmenSelect
                    }
                  />

                  <div></div>

                  <div>
                    <SimpleInputRow
                      label={"Locator Name"}
                      name="locator"
                      // readOnly={this.props.type !== "create"}
                      value={this.state.data.locator}
                      onChange={this.onchangeInput}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div
                    //   style={{ float: "left", marginRight: "1vw" }}
                    className="padding-top-5px padding-bottom-10px"
                  >
                    <button
                      style={{ marginLeft: "600px" }}
                      className="btn btn-green"
                      type="submit"
                      onClick={() => {
                        console.log("clicked");
                        this.onPostCreate();
                      }}
                    >
                      <span>{!this.state.loadSave ? "SAVE" : "Saving..."}</span>
                    </button>

                    <button
                      style={{ marginLeft: "40px" }}
                      className="btn btn-back"
                      type="button"
                      onClick={this.onClearFieldButton.bind(this)}
                    >
                      <span>CLEAR</span>
                    </button>
                  </div>
                </div>
                <div className="padding-top-10px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"Locator List"}
                      subtitle={"Setting data of Locator List"}
                      data={this.state.dataTable3}
                      columns={this.columnsUser3}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      style={{ marginLeft: "1290px", width: "50" }}
                      className="btn btn-back"
                      type="button"
                    >
                      <span>PRINT</span>
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormLocator
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible2 && (
            <FormPDI
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm2.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormLocator
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.failedPopUpVisible && (
            <PopUp
              type={"confirm"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp2.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(warehouse);
